// const PAYMENT_TYPE_CARD = 1
// const PAYMENT_TYPE_ONLINE = 2
// const PAYMENT_TYPE_CERTIFICATE = 3
// const PAYMENT_TYPE_MASTER_PAY = 4
// const PAYMENT_TYPE_COMPANY_PAY = 5
// const PAYMENT_TYPE_COMPANY_PROMO = 6
// const PAYMENT_TYPE_CLUB_CARD = 7
// const PAYMENT_TYPE_CASH = 8
// const PAYMENT_TYPE_TINKOFF = 9
// const PAYMENT_TYPE_SBER_QR = 10
// const PAYMENT_TYPE_TINKOFF_QR = 11
// const PAYMENT_TYPE_BONUS = 18

export const PAYMENTS_TYPES = {
  PAYMENT_TYPE_CASH: 'cash', // Оплата наличными
  PAYMENT_TYPE_CARD: 'cashless', // Оплата наличными
  PAYMENT_TYPE_TINKOFF_ONLINE: 'tinkoff_online', // Картой через сервис Тинькоф
  PAYMENT_TYPE_TINKOFF_QR: 'tinkoff_qr', // С помощью Тинькоф QR
  PAYMENT_TYPE_TINKOFF_CREDIT_FOR_3_MONTHS: 'tinkoff_credit_for_3_months', // В кредит на 3 месяца через Тинькоф
  PAYMENT_TYPE_TINKOFF_CREDIT_FOR_4_MONTHS: 'tinkoff_credit_for_4_months', // В кредит на 4 месяца через Тинькоф
  PAYMENT_TYPE_TINKOFF_CREDIT_FOR_6_MONTHS: 'tinkoff_credit_for_6_months', // В кредит на 6 месяцев через Тинькоф
  PAYMENT_TYPE_DOLYAME: 'dolyame', // Через сервис "Долями"
  PAYMENT_TYPE_EMPLOYER_PAY: 'employer_pay', // За счет мастера
  PAYMENT_TYPE_COMPANY_PAY: 'company_pay', // За счет компании
  PAYMENT_TYPE_CERTIFICATE: 'certificate', // Сертификатом
  PAYMENT_TYPE_CLUB_CARD: 'club_card', // Клубной картой
  PAYMENT_TYPE_BONUS: 'bonuses', // Бонусами
  PAYMENT_TYPE_PROMO_CODE: 'promo_code', // Промокодом
  PAYMENT_TYPE_SELF_EMPLOYED: 'self_employed', // Самозанятые. Наличные
  PAYMENT_TYPE_SBER_QR: 'sber_pay_qr', // Самозанятые. Наличные
}
